export enum AssetClassCode {
  ACAO = "ACAO",
  FII = "FII",
  BDRS = "BDR",
}

export type AssetsSearchResult = {
  currency: string;
  logo_url: string;
  long_name: string;
  price: number;
  short_name: string;
  ticker: string;
  type: AssetClassCode;
  regular_market_change: number
  regular_market_change_percent: number
};

export type Asset = {
  currency: string;
  earnings_per_shared: number
  logo_url: string;
  long_name: string;
  market_cap: number
  price: number;
  price_earnings: number
  regular_market_change: number
  regular_market_change_percent: number
  short_name: string;
  summary_profile: {
    website: string
  }
  ticker: string;
  type: AssetClassCode;
}

export type FlatAsset = {
  id: string;
  ticker: string;
  rating: number;
  quantity: number;
  averagePrice: number;
  logoUrl?: string;
  price?: number | null;
  shortName?: string | null;
  classId: string;
  classCode: AssetClassCode;
  className: string;
  classColor: string;
  amountInvested: number | null;
  amountInvestedIsEstimated: boolean;
  currentValue: number | null;
};